import { createFileRoute } from '@tanstack/react-router'
import ConceptDetailedInformation from 'Concept/components/Concept/Sections/ConceptDetailedInformation'

import { Guard } from '../../-guard'

export const Route = createFileRoute('/concept/$conceptId/detailedInfo')({
    component: () => (
        <Guard notFeatures={['profitability']}>
            <ConceptDetailedInformation />
        </Guard>
    ),
})
